import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useRef, useEffect } from 'react';
import { useInView as useInViewLib } from 'react-intersection-observer';
import { useBooleanState } from './useBooleanState';
import { identity } from 'ramda';

/* istanbul ignore next */
var loadIntersectionObserver = identity(function () {
  return import('intersection-observer');
});
var hasNativeIntersectionObserver = typeof IntersectionObserver !== 'undefined';

/** Состояние модуля, показывает, загружался ли уже полифилл ранее */
var isPolyfillLoadedBefore = false;

/**
 * Хук оборачивает оригинальный useInView, добавляя загрузку полифилла при необходимости
 * В случае, если IntersectionObserver нативно не поддерживается и еще не загрузился, хук вернет пустую рефку
 * Пустая рефка не запускает использование IntersectionObserver, поэтому ошибка не возникает
 * */
export var useInView = hasNativeIntersectionObserver ? useInViewLib : function (args) {
  var noopRef = useRef(null);
  var result = useInViewLib(args);
  var _useBooleanState = useBooleanState(isPolyfillLoadedBefore),
    _useBooleanState2 = _slicedToArray(_useBooleanState, 2),
    isPolyfillLoaded = _useBooleanState2[0],
    setPolyfillLoaded = _useBooleanState2[1];
  useEffect(function () {
    /** Если полифилл уже загружен, не нужно делать ничего лишнего */
    if (isPolyfillLoadedBefore) {
      return;
    }
    var componentStillMounted = true;
    loadIntersectionObserver().then(function () {
      isPolyfillLoadedBefore = true;

      /**
       * Если компонент к моменту загрузки полифилла уже размаунтился, стейт обновлять не нужно.
       * Сложно протестить
       * */
      /* istanbul ignore next */
      if (componentStillMounted) {
        setPolyfillLoaded();
      }
    }).catch(function () {
      return null;
    });
    return function () {
      componentStillMounted = false;
    };
  }, [setPolyfillLoaded]);
  return isPolyfillLoaded ? result : _objectSpread(_objectSpread({}, result), {}, {
    ref: noopRef
  });
};